import React from "react";
import { ShieldCheckIcon } from "lucide-react";
import { TransformButton } from "./CtaButton";
export function Guarantee() {
  return <section className="w-full bg-neutral-900 py-14" data-id="element-88" data-mp="1o33xor06cami">
      <div className="mx-auto max-w-lg px-4" data-id="element-89" data-mp="223y4543nw1ij">
        <div className="rounded-2xl border border-emerald-500/25 bg-emerald-500/[0.06] p-6 text-center" data-id="element-90" data-mp="222n1j7lyczt0">
          <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-emerald-500/15" data-id="element-91" data-mp="1x54tdjfreom2">
            <ShieldCheckIcon className="h-9 w-9 text-emerald-400" data-id="element-92" data-mp="19ceh193y23b9" />
          </div>
          <h2 className="mt-4 font-display text-2xl font-extrabold text-white" data-id="element-93" data-mp="14hh8e3aktvyw">
            🛡️ Garantía Blindada de 7 Días
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-white/70" data-id="element-94" data-mp="1ee3s2or62gzc">
            Sabemos que comprar por Internet puede generar dudas. Por eso
            queremos asumir todo el riesgo nosotros.
          </p>
          <p className="mt-3 text-sm leading-relaxed text-white/70" data-id="element-95" data-mp="lpohqfizcmuc">
            Descarga el Sistema Técnico PRO 360™, revisa cada sistema, explora
            todas las plantillas y evalúa cómo puede ayudarte a organizar mejor
            tu negocio.
          </p>
          <p className="mt-3 text-sm leading-relaxed text-white/85" data-id="element-96" data-mp="tw9qf3zza08z">
            Si durante los próximos 7 días sientes que el sistema no cumple con
            lo prometido, solo escríbenos. Te devolveremos el{" "}
            <span className="font-bold text-emerald-400" data-id="element-97" data-mp="60x9n2wkjfk6">
              100% de tu dinero.
            </span>
          </p>
          <p className="mt-4 text-sm font-semibold text-white" data-id="element-98" data-mp="ayyu9s9n7mxr">
            Sin formularios complicados. Sin llamadas. Sin preguntas incómodas.
          </p>
        </div>

        <div className="mt-8 flex justify-center" data-id="element-99" data-mp="k0f0roxc74wp">
          <TransformButton label="Quiero probarlo sin riesgo" data-id="element-100" data-mp="k1zyfney73ys" />
        </div>
      </div>
    </section>;
}